export class NbiDimensions {
  public FPV_BL = "fpv_bl";
  public FPV_SBL = "fpv_sbl";
  public FPV_SSBL = "fpv_ssbl";
  public FPV_SALES = "fpv_sales"; // to be checked
  public SALESBEN_SALES = "salesben_sales";
  public SALESBEN_BUNAME = "salesben_buname";
  public SALESBEN_TEAM = "salesben_team";
  public SALESBEN_COUNTRY = "salesben_country";
  public SALESBEN_SALES_LOCATION = "salesben_saleslocation";
  public PERIOD_MONTH_ID = "period_month_id";
  public PERIOD_MONTH_LABEL = "period_month_label";
  public PRODUCT_LEVEL1 = "product_l1";
  public PRODUCT_LEVEL2 = "product_l2";
  public PRODUCT_LEVEL3 = "product_l3";
  public PRODUCT_LEVEL4 = "product_l4";
  public OE_RES_REG = "fpv_oeresreg";
  public OE_RES_REG_CODE = "fpv_oeresregcode";
  public OE_RES_CTRY = "fpv_oeresctry";
  public OE_RES_CTRY_NAME = "fpv_oeresctryname";
  public BE_RES_CTRY = "fpv_beresctry";
  public BE_RES_CTRY_NAME = "fpv_beresctryname";
  public CALENDAR_DATE = "calendar_date";
  public CALENDAR_QUARTER_LABEL = "calendar_quarter_label";
  public CALENDAR_MONTH_LABEL = "calendar_month_label";
  public GBIS_CREDIT_DATE = "gbis_credit_date";
  public CLIENT_LEID = "client_leid";
  public CLIENT_GEN_ID = "clientgen_id";
  public CLIENT_GEN_NAME = "clientgen_name";
  public CLIENT_LEVEL = "client_lavel";
  public CLIENT_PCRU = "client_coripcru";
  public CLIENT_SHORT_PCRU = "clientgen_shortfupclasslabel";
  public CLIENT_CORIGRPNAME = "client_corigrpfullname";
  public CLIENT_CORIGRPCOMID = "client_corigrpcomid";
  //  #TODO : mapping on cori client to delete ....

  // public CLIENT_CORIGRPCTRYNAME = "client_corigrpctryname";
  public CLIENT_CORIGRPSEGMENT = "client_corigrpsegment";
  public CLIENT_CORI_CTRY_AXIS = "client_coricountryaxis";

  public CLIENT_LEADCORIBANKER = "client_leadcoribanker";
  public CTRY_CODE = "client_lecomctry";
  public FPV_NE_CTRY = "fpv_oeresctryname";
  public SALESBEN_CTRY = "salesben_country";
  public EC_REG = "client_eccomregname";
  public EC_CTRY = "client_eccomctrycode";
  public OE_SHORT_LABEL = "fpv_oeshortlabel";
  public BE_SHORT_LABEL = "fpv_beshortlabel";
  public AGENCY_DEC_LONG_NAME = "agency_declongname";
  public BE_CTRY = "fpv_beresctryname";
  // public GRP_ID = "client_id";
  public GRP_FULL_NAME = "client_grpname";
  public MONTH = "calendar_month";
  public YEAR = "calendar_year";
  public SUB_GRP_ID = "client_subgrpid";
  public SUB_GRP_FULL_NAME = "client_subgrpname";
  public LE_ID = "client_leid";
  public CLIENT_LENAME = "client_lename";
  public GRP_SEGMENT = "clientgen_segment";
  public GRP_COUNTRY = "client_grpcomctryname";
  public GRP_COMREGION = "client_grpcomregname";
  public GRP_TYPL1 = "client_grptypl1name";
  public GRP_TYPL2 = "client_grptypl2name";
  public GRP_TYPL3 = "client_grptypl3name";
  public GRP_COMSUBREGION = "client_grpcomsubregname";

  public CLIENT_GEN_COM_CTRY_LABEL = "clientgen_comctrylabel";
  public CLIENT_GEN_REG_NAME = "clientgen_regname";
  public CLIENT_GEN_SUB_REG_NAME = "clientgen_subregname";
  public CLIENT_GEN_LEVEL = "clientgen_level";
  public CLIENT_GEN_FUP_CLASS_LABEL = "clientgen_fupclasslabel";
  public CLIENT_GEN_SEGMENT = "clientgen_segment";
  public CLIENT_GEN_CTRY_AXIS_LABEL = "clientgen_ctryaxiscode";

  public CLIENT_GEN_TYPL1 = "clientgen_typol1name";
  public CLIENT_GEN_TYPL2 = "clientgen_typol2name";
  public CLIENT_GEN_TYPL3 = "clientgen_typol3name";

  public EC_ID = "client_eccomid";
  public EC_FULL_NAME = "client_ecfullname";
  public CLIENT_COUNTRY = "client_lecomctryname";
  public SALES = "salesben_sales";
  public SALES_TEAM_NAME = "salesben_team";
  public IS_IB = "is_ib";
  public COVERAGE_ROLE = "coverage_role";
  public IB_LABEL = "ib_label";
  public COVERAGE_INHERITED = "coverage_inherited";
  public BOOKING_PLACE = "booking_place";
  public RWA_CLOSE_OFF_PERIOD = "rwa_close_off_period";
  public CLIENT_LE_RCT_CODE = "client_lerctcode";
  public RWA_CLOSE_OFF_DATE = "rwa_close_off_date";
  public DIM_DEAL_CODE = "dim_deal_code";
  public PO_LEFULLNAME = "po_lefullname";
  public CLIENT_GRPID = "client_grpid";

  public NBI_GBIS_LEVEL_1_FUNCTIONAL_LABEL = "gbis_level_1_functional_label";
  public NBI_GBIS_LEVEL_6_FUNCTIONAL_LABEL = "gbis_level_6_functional_label";
  public NBI_GBIS_LEVEL_7_FUNCTIONAL_LABEL = "gbis_level_7_functional_label";

  public CLIENT_GRP_COM_CONTINENT = "client_grpcomcontinentname";
  public CLIENT_GRP_COUNTRY_AXIS = "client_grpcountryaxis";
  public CLIENT_GRP_COM_COUNTRY_GRP_NAME = "client_grpcomctrygrpname";
  public CLIENT_GRP_FUP_CLASS_LABEL = "client_grpfupclasslabel";
  public CLIENT_GRP_SEGMENT = "client_grpsegment";
  public FPV_BE_RESG = "fpv_beresreg";
  public GBIS_FEEDER_APPNAME = "gbisfeeder_appname";
  public GBIS_ORIGINAPP_APPNAME = "gbisoriginapp_appname";

  public PRODUCT_LABEL = "product_label";
  public PRODUCT_CODE = "product_code";

  public SC_CLI_MARK_CURRENCY_EMG10 = "markdeals_currency_emg10";
  public SC_CLI_MARK_CURRENCY_ZONES = "markdeals_currency_zones";
  public SC_CLI_MARK_CURRENCY = "markdeals_currency";

  public SC_OVERVIEW_USD = "salescredit_overview_usd";
}
